import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useSelectedRows } from '../tabla/SelectedRowsContext';
import '../../estilo/App.css';
import ConfirmGenerarContModal from '../modales/GenerarContestModal';
import axiosInstancePromise from '../../general/axiosConfig';
import ProgressBarModal from '../modales/ProgressBar';

const BtnGenContestacion = ({table, funcSenal}) => {
  const { selectedRows, setSelectedRows} = useSelectedRows();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openModalBar, setOpenModalBar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  
  const handleGenerarContest = (user) => {
    setOpenConfirmModal(true);
  };

  const handleConfirmGenerar = async (data) => {
    setOpenConfirmModal(false);
    setOpenModalBar(true);
    try {
      const ides = selectedRows.map(row => row['id']);
      const facturas = selectedRows.map(row => row['numero_factura']);
      const axiosInstance = await axiosInstancePromise;

      const response = await axiosInstance.post("/generar-contestacion", {ides, facturas,}, {
        validateStatus: status => status === 202 || (status >= 200 && status < 300)
      });

      const taskIds = Array.isArray(response.data.job_ids)
        ? response.data.job_ids
        : response.data.job_ids.split(",").map(id => id.trim()).filter(Boolean);

      if (taskIds.length === 0) {
        throw new Error("No se recibieron tareas para verificar.");
      }
     
      const checkInterval = setInterval(async () => {
        try {
          const statusRes = await axiosInstance.post('/task-status', {
            task_id: taskIds
          });

          const statusMap = statusRes.data;

          const allDone = taskIds.every(id => {
            const state = statusMap[id]?.status;
            return state === 'SUCCESS' || state === 'FAILURE';
          })

          if (allDone) {
            clearInterval(checkInterval);
            setOpenModalBar(false);

            const anyFailures = taskIds.some(id => statusMap[id]?.status === 'FAILURE');
            setSnackbarMessage(anyFailures
                ? "Una o más tareas fallaron al generar respuestas."
                : "¡Todas las respuestas fueron generadas con éxito!"
            );
            setSnackbarSeverity(anyFailures ? 'error' : 'success');
          }
          
          funcSenal();
        } catch (e) {
          clearInterval(checkInterval);
          console.error("Error al verificar estado de tareas:", e);
          setOpenModalBar(false);
          setSnackbarMessage("Error al verificar el estado de la tarea.");
          setSnackbarSeverity("error");
        }
      }, 5000);
  
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setSnackbarMessage("Hubo un error al generar las respuestas.");
      setSnackbarSeverity('error');
      setOpenModalBar(false);
    }
    setSelectedRows([]);

  };

  return (
    <Box>
      <Box>
        <Button
        sx={{mt:2}} 
        variant="outlined" 
        onClick={handleGenerarContest}
        disabled={selectedRows.length === 0}
        >
          Generar Respuesta a glosa
        </Button>
      </Box>
      <ConfirmGenerarContModal
        open={openConfirmModal}
        handleClose={() => setOpenConfirmModal(false)}
        handleConfirm={handleConfirmGenerar} 
      />
      <ProgressBarModal open={openModalBar} duration={(selectedRows.length * 1000) + 3000}
        message={'Generando respuestas...'}
        snackbarMessage={snackbarMessage} 
        severity={snackbarSeverity}
        onClose={() => setOpenModalBar(false)}/>
    </Box>
  );
};

export default BtnGenContestacion;
